<template>
  <b-card class="admin-options mb-3" :body-class="show ? '' : 'p-0'">
    <b-button variant="link" block class="text-danger" @click="show = !show">
      {{ trans('admin_options') }}
      <i :class="`fa fa-fw fa-caret-${show ? 'up' : 'down'}`"></i>
    </b-button>
    <div v-if="show" class="text-left">
      <b-form-group :label="trans('item_price')">
        <b-form-input size="sm" v-model="price" lazy-formatter :formatter="formatter" :state="isPriceValid" :disabled="busy" />
      </b-form-group>
      <b-form-group :label="trans('item_name')">
        <b-form-input size="sm" v-model="name" :state="isNameValid" :disabled="busy" />
      </b-form-group>
      <b-form-group :label="trans('taxes')">
        <b-form-checkbox v-model="apply_taxes" switch :disabled="busy">
          {{ apply_taxes ? trans('yes') : trans('no') }}
        </b-form-checkbox>
      </b-form-group>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
      <b-button variant="danger" size="sm" :disabled="busy || !canApply" @click="onApplyAdminItem">
        {{ trans('apply') }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
  export default {
    props: {
      organization: Object,
      product: Object,
      invoice_item: Object,
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        busy: false,
        error: null,
        show: false,
        price: this.invoice_item.price,
        name: this.invoice_item.name,
        apply_taxes: !!this.invoice_item.tax_info,
      }
    },
    computed: {
      isPriceValid() {
        if (this.price === null || this.price === undefined || this.price === '') return false
        let value = parseFloat(this.price)
        if (isNaN(value) || value < 0) return false
        return true
      },
      isNameValid() {
        return this.name && this.name.length > 0 && this.name.length < 200
      },
      canApply() {
        return this.isPriceValid && this.isNameValid
      },
    },
    watch: {
      invoice_item() {
        this.price = this.invoice_item.price
        this.name = this.invoice_item.name
        this.apply_taxes = !!this.invoice_item.tax_info
      },
    },
    methods: {
      formatter(value) {
        if (value === null || value === undefined || value === '') return ''
        return numeral(value).format('0.00')
      },
      onApplyAdminItem() {
        this.busy = true
        this.error = null
        axios.patch(`/org/${this.organization.id}/cart/product/${this.invoice_item.id}`, {
          price: this.price,
          name: this.name,
          apply_taxes: this.apply_taxes
        })
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
  }
</script>